import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

interface DeleteReceipt {
  graph_id: string;
  deleted: boolean;
  nodes_deleted: number;
  edges_deleted: number;
}

const remove = async (
  graphId: string,
  kind: 'entities' | 'facts',
  id: string,
): Promise<DeleteReceipt> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<DeleteReceipt>({
    url: `/context-graphs/${orgId}/${graphId}/${kind}/${id}`,
    method: 'DELETE',
    target: 'platform',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }
  if (!response.data) {
    throw new Error('Unexpected response format');
  }
  return response.data;
};

export const removeContextGraphEntity = (graphId: string, entityId: string) =>
  remove(graphId, 'entities', entityId);

export const removeContextGraphFact = (graphId: string, factId: string) =>
  remove(graphId, 'facts', factId);
